import type { ReactElement } from 'react';
import { StatusIcon } from '../status-icon/status-icon';
import { AvatarIconOverlay } from './avatar-icon-overlay';
import { AvatarFlagBadge } from './avatar-flag-badge';
import type { AvatarBadge } from './types';

export function AvatarBadgeOverlay({
  badge,
  iconSize,
}: {
  badge: AvatarBadge;
  iconSize: '16' | '20';
}): ReactElement {
  if (badge.type === 'status') {
    return (
      <AvatarIconOverlay iconAltValue={badge.alt} iconSize={iconSize} iconTestId="avatar-badge">
        <StatusIcon size={iconSize} status={badge.status} />
      </AvatarIconOverlay>
    );
  }

  // badge.type === 'flag'
  return <AvatarFlagBadge code={badge.code} iconSize={iconSize} />;
}
